import mcu1FirmwareUrl from '../../M9deviceMcu120260731ID00007D40V00000164.bin';
import mcu2FirmwareUrl from '../../M9deviceMcu220260731ID00007D50V00000164.bin';

const FIRMWARE_CATALOG = Object.freeze({
  'darmoshark-m9': Object.freeze({
    mcu1: Object.freeze({
      label: 'MCU1',
      displayLabel: 'USB芯片',
      mcuNumber: 1,
      expectedProductId: 0x7d40,
      directoryUrl: '/firmware/m9/',
      externalUrl: '/firmware/m9/mcu1.bin',
      externalName: 'firmware/m9/mcu1.bin',
      bundledName: 'M9deviceMcu120260731ID00007D40V00000164.bin',
      bundledUrl: mcu1FirmwareUrl,
    }),
    mcu2: Object.freeze({
      label: 'MCU2',
      displayLabel: 'RF芯片',
      mcuNumber: 2,
      expectedProductId: 0x7d50,
      directoryUrl: '/firmware/m9/',
      externalUrl: '/firmware/m9/mcu2.bin',
      externalName: 'firmware/m9/mcu2.bin',
      bundledName: 'M9deviceMcu220260731ID00007D50V00000164.bin',
      bundledUrl: mcu2FirmwareUrl,
    }),
  }),
});

export function getFirmwareFiles(modelId) {
  return FIRMWARE_CATALOG[modelId] || null;
}

export function getFirmwareDisplayLabel(file) {
  return file?.displayLabel || file?.label || '';
}

export default FIRMWARE_CATALOG;
